import { Controller } from "@hotwired/stimulus"

// Опрос статуса web-генерации БЕЗ перезагрузки страницы: пока фрагмент результата
// помечен data-done="false", периодически подтягивает свежий HTML и подменяет только
// фрейм результата (варианты появляются по мере готовности).
export default class extends Controller {
  static targets = ["frame"]
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.tick()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  tick() {
    if (this.frameTarget.dataset.done === "true") return
    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  async refresh() {
    try {
      const resp = await fetch(window.location.href, { headers: { Accept: "text/html" } })
      if (resp.ok) {
        const doc = new DOMParser().parseFromString(await resp.text(), "text/html")
        const fresh = doc.querySelector("[data-poll-target='frame']")
        if (fresh) this.frameTarget.replaceWith(fresh)
      }
    } catch (_) {
      // сеть моргнула — просто попробуем на следующем тике
    }
    this.tick()
  }
}
